import React from 'react';
import styles from './RoomCapacityList.module.scss';

const RoomCapacityList = ({ containerStyles, children }) => (
  <div className={`${containerStyles} ${styles.capacityList} flex flex-wrap flex-v-center`}>
    {children}
  </div>
);

RoomCapacityList.defaultProps = {

};

export default RoomCapacityList;
